import React from "react";

interface ContentCardProps {
  title: string;
  children: React.ReactNode;
  action?: React.ReactNode;
  className?: string;
}

/**
 * A bordered card with an optional header and action slot.
 * Used for sections like trace display with JSON toggle.
 */
export function ContentCard({
  title,
  children,
  action,
  className = "",
}: ContentCardProps) {
  return (
    <div
      className={`rounded-lg border border-border bg-card p-4 shadow-sm ${className}`}
    >
      <div className="flex items-center justify-between mb-2">
        <span className="text-xs font-medium text-muted-foreground uppercase tracking-wider">
          {title}
        </span>
        {action}
      </div>
      {children}
    </div>
  );
}
